const initialState =
{
    data: [],
    saving: false,
};

export default (state = initialState, action) => {
    switch(action.type)
    {
         case 'LIST':
            return {
                ...state,
            }
        case 'SAVE_ALERTA':
            return {
                ...state,
                saving: false,
                data: [...state.data, action.payload]
            }
        case 'Eliminar_notificacion':

        let temporal =state.data;
        for (var key in temporal) {
            // console.log('alerta--->',temporal[key])
            // console.log('creacion--->',temporal[key].creacion)
            // console.log('payload--->',action.payload)
            if (temporal[key].creacion == action.payload) {
                temporal.splice(key, 1);
                
            }
        }
            return {
                ...state,
                saving: false,
                data:temporal,
            }        

        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/notificaciones.js